import { isAxiosError } from '@/portainer/services/axios/utils/isAxiosError';
import { parseAxiosError } from '@/react/portainer/services/axios/utils/parseAxiosError';

export function resolveAuthError(err: unknown, defaultMessage: string): string {
  if (!isAxiosError(err)) return defaultMessage;
  return parseAxiosError(err).message || defaultMessage;
}
